import styled from 'styled-components'

const SupplierUpdateContainer = styled.div`
  .MuiCard-root {
    height: 100%;
  }
`

export default SupplierUpdateContainer
